interface ConsultationTypeCardProps {
  icon: string;
  title: string;
  description: string;
  duration: string;
  isSelected: boolean;
  onClick: () => void;
}

export default function ConsultationTypeCard({
  icon,
  title,
  description,
  duration,
  isSelected,
  onClick,
}: ConsultationTypeCardProps) {
  return (
    <button
      onClick={onClick}
      className={`w-full p-6 rounded-lg border-2 transition-all duration-300 text-left ${
        isSelected
          ? 'border-accent bg-accent/5 shadow-lg'
          : 'border-border hover:border-accent/50 hover:shadow-md'
      }`}
    >
      <div className="flex items-start space-x-4">
        <div
          className={`flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center ${
            isSelected ? 'bg-accent text-white' : 'bg-muted text-primary'
          }`}
        >
          <span className="text-2xl">{icon}</span>
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-heading font-semibold text-foreground mb-1">
            {title}
          </h3>
          <p className="text-sm text-muted-foreground mb-2">{description}</p>
          <span className="text-xs font-medium text-accent">{duration}</span>
        </div>
      </div>
    </button>
  );
}